module.exports = __webpack_public_path__ + "static/espruar_message_SCAG-cd98899fc82444ae0d740c12571a0eac.png";